import { render, staticRenderFns } from "./Tramite.vue?vue&type=template&id=21d51c9e&scoped=true"
import script from "./Tramite.vue?vue&type=script&lang=js"
export * from "./Tramite.vue?vue&type=script&lang=js"
import style0 from "./Tramite.vue?vue&type=style&index=0&id=21d51c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d51c9e",
  null
  
)

export default component.exports